var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InputSelectionList, } from '@dixa/lib-shared-habla';
import { useCallback, useMemo, useState } from 'react';
import { useLanguageSelectionList, } from 'utils/useLanguageSelectionList';
import { useLanguageSelectionListItems } from 'utils/useLanguageSelectionListItems';
/**
 * Represents a selection list of languages for translating text to a selected
 * language.
 */
export const CopilotLanguageInputSelectionList = (props) => {
    const { selectedLanguageCode, onLanguageChange, sortFn = (a, b) => a.name.localeCompare(b.name) } = props, inputSelectionListProps = __rest(props, ["selectedLanguageCode", "onLanguageChange", "sortFn"]);
    const [searchTerm, setSearchTerm] = useState('');
    const languageSelectionListOptions = useMemo(() => ({
        selectedLanguageCodes: selectedLanguageCode
            ? [selectedLanguageCode]
            : undefined,
    }), [selectedLanguageCode]);
    const { languages, selectedLanguages, onChange, recentlyUsedLanguagesCodes } = useLanguageSelectionList(languageSelectionListOptions);
    const languageSelectionListItems = useLanguageSelectionListItems({
        languages,
        searchTerm,
        recentlyUsedLanguagesCodes,
        sortFn,
    });
    const handleOnChange = useCallback((event) => {
        var _a, _b;
        onChange(event);
        if ((_a = event.selectedItem) === null || _a === void 0 ? void 0 : _a.value) {
            onLanguageChange === null || onLanguageChange === void 0 ? void 0 : onLanguageChange({ selectedLanguage: (_b = event.selectedItem) === null || _b === void 0 ? void 0 : _b.value });
        }
    }, [onChange, onLanguageChange]);
    return (_jsx(InputSelectionList, Object.assign({}, inputSelectionListProps, { getItemTitleByValue: (value) => value.name, value: selectedLanguages, onChange: handleOnChange, placeholder: "Select a language", filter: {
            value: searchTerm,
            onChange: (event) => setSearchTerm(event.target.value),
        }, dropdownProps: {
            style: { maxHeight: 400, overflow: 'auto' },
        } }, { children: languageSelectionListItems })));
};
